<pv2-playable-list
  [items]="menuItems()"
  [eventSource]="eventSource()"
  [displayPlayButtons]="displayPlayButtons()"
  [displayDurations]="displayDurations()"
>
</pv2-playable-list>
